import React from 'react';
import { useHistory } from 'react-router-dom';

import {
    IconBroadcast,
    // IconChartLine1,
    IconInfoCircle,
} from '@trqk/components';

import { locale } from '@trqk/utils';

import { FULL_PATHS, HASHES } from '../../../../constants';

interface EmptyStateProps {
    detectionIsEnabled: boolean;
    hasTrqkAudio: boolean;
    hasTrqkSong: boolean;
}

/**
 * An empty state that is shown for an unmatched work without detection enabled. Prompts the user
 * to match the work or turn on detection in order to see data.
 * @param props - see {@link EmptyStateProps}
 */
export const EmptyState = ({
    detectionIsEnabled,
    hasTrqkAudio,
    hasTrqkSong,
}: EmptyStateProps): JSX.Element => {
    const history = useHistory();

    return (
        <div
            className="w-full flex items-center justify-center bg-white rounded-lg my-6 text-sm font-normal"
            style={{ height: 400 }}
        >
            <div className="flex flex-col items-center text-tertiary-400 italic">
                {hasTrqkSong && (
                    <div className="my-2 flex flex-col items-center">
                        <div className="flex items-center">
                            <IconInfoCircle addClasses="mr-2" />
                            {
                                locale.enUS.TRACK_DETAIL.EMPTY_STATE
                                    .CHANGE_SELECTION_1
                            }
                        </div>
                        <div className="flex items-center my-2">
                            {
                                locale.enUS.TRACK_DETAIL.EMPTY_STATE
                                    .CHANGE_SELECTION_2
                            }
                        </div>
                    </div>
                )}
                {!hasTrqkSong && (
                    <div className="flex items-center my-2">
                        <IconInfoCircle
                            addClasses="mr-2"
                            fillColor="primary-500"
                            width={20}
                        />
                        {
                            locale.enUS.TRACK_DETAIL.EMPTY_STATE
                                .NO_PERFORMANCE_DATA
                        }
                    </div>
                )}
                {!detectionIsEnabled && hasTrqkAudio && (
                    <div className="flex items-center my-2">
                        <IconBroadcast addClasses="mr-2" />
                        {locale.enUS.TRACK_DETAIL.EMPTY_STATE.SEE_DETECTIONS_1}
                        &nbsp;
                        <button
                            type="button"
                            className="underline italic"
                            onClick={(): void => {
                                history.push({
                                    search: history.location.search,
                                    pathname: FULL_PATHS.MANAGE_DETECTIONS,
                                    hash: HASHES.MANAGE_DETECTIONS
                                        .DETECTION_SETTINGS,
                                });
                            }}
                        >
                            {
                                locale.enUS.TRACK_DETAIL.EMPTY_STATE
                                    .SEE_DETECTIONS_2
                            }
                        </button>
                        &nbsp;
                        {locale.enUS.TRACK_DETAIL.EMPTY_STATE.SEE_DETECTIONS_3}
                    </div>
                )}
            </div>
        </div>
    );
};
